import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { WSPScorecardDto } from "../../../../Component/Model/Dto/ScorecardLicense";
import { TableColumn } from "../../../../Component/Model/Table/Table";
import { DateFormatter } from "../../../../Component/Model/helpers";

interface WSPScorecardRows {
    id: string;
    name: ILinkProps;
    organisationName: string;
    setaType: string;
    startDate: string;
    endDate: string;
    createdDate: string;
}

interface ILinkProps {
    linkTo: string;
    itemName: string;
}

interface WSPScorecardsTable {
    columns: Array<TableColumn>;
    rows: Array<WSPScorecardRows>;
}

export function WSPScorecardsTableMapper(dataObject: WSPScorecardDto[]): WSPScorecardsTable {

    const columns = [
        { Header: 'Name', accessor: 'name', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" component={Link} to={value.linkTo}>{value.itemName}</Typography> },
        { Header: 'SETA', accessor: 'setaType', id: 'setaType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Organisation', accessor: 'organisationName', id: 'organisationName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Start Date', accessor: 'startDate', id: 'startDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'End Date', accessor: 'endDate', id: 'endDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created Date', accessor: 'createdDate', id: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    ];
    if (dataObject != undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: WSPScorecardDto, index: number) => ({
            id: item.id,
            name: { linkTo: `/wsp/scorecard/${item.id}/Dashboard`, itemName: item.name},
            setaType: item.seta, 
            organisationName: item.organisationName,
            startDate: DateFormatter(item.startDate.toString()),
            endDate: DateFormatter(item.endDate.toString()),
            createdDate: DateFormatter(item.createdDate.toString())
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}